import { InjectionToken } from "@angular/core";
import { AppConfig } from "./app.config";

export const appConfigToken = new InjectionToken<AppConfig>('Application Configuration');
